import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { LabelledTextBoxComponent, LoaderComponent, ModalComponentInterface, NTSTranslatePipe } from '@nts/std';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { AsyncPipe, NgIf } from '@angular/common';

import { LicenseReportViewModel } from '../../view-models/license-report.view-model';
// import { sharedIcons } from "../svg/shared";

@UntilDestroy()
@Component({
    selector: 'nts-generate-cost-review-data-modal-container',
    templateUrl: 'generate-cost-review-data-modal-container.component.html',
    styleUrls: ['./generate-cost-review-data-modal-container.component.scss'],
    standalone: true,
    imports: [
        NTSTranslatePipe,
        LoaderComponent,
        SvgIconComponent,
        AsyncPipe,
        NgIf
    ],
    providers: [
        // provideSvgIcons([...sharedIcons])
    ]
})

export class GenerateCostReviewDataModalContainerComponent implements OnInit {
    @Input() viewModel: LicenseReportViewModel;

    @ViewChild('inputFile') inputFile: ElementRef;

    constructor(
        private cd: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.viewModel.initialize(null);
        if (this.viewModel?.changed) {
            this.viewModel.changed.pipe(untilDestroyed(this)).subscribe(() => {
                this.cd.detectChanges();
            })
        }

        this.viewModel.hasError$.pipe(untilDestroyed(this)).subscribe((hasError: boolean) => {
            this.updateStyle(hasError);
            if (hasError) {
                this.resetInput();
            }
        })
    }


    updateStyle(hasError: boolean) {

        if (hasError) {
            const border = document.getElementsByClassName("image-upload-wrap")[0] as HTMLElement;
            border.style.borderColor = "#FD0F0F";

            const dragText = document.getElementsByClassName("drag-text")[0] as HTMLElement;
            dragText.style.color = "#FD0F0F";
        } else {
            const border = document.getElementsByClassName("image-upload-wrap")[0] as HTMLElement;
            border.style.borderColor = "#006FDD";

            const dragText = document.getElementsByClassName("drag-text")[0] as HTMLElement;
            dragText.style.color = "#006FDD";
        }
    }

    reset() {
        this.viewModel.reset();
        this.resetInput();
    }

    resetInput() {
        if (this.inputFile) {
            this.inputFile.nativeElement.value = '';
        }
    }
}
